export default (restServer) => ({
    GET_TRS_AGREEMENTS: (custodianId) => restServer(`/internal/api/legalentity/v1/agreements/trs/${custodianId}`),
    GET_BORROW_AGREEMENTS: (custodianId) => restServer(`/internal/api/legalentity/v1/agreements/borrow/${custodianId}`),
    GET_ALL_COUNTERPARTIES: () => restServer("/internal/api/legalentity/v1/counterparties/all"),
    GET_ALL_COUNTERPARTIES_PATH: () => "/internal/api/legalentity/v1/counterparties/all",
    GET_CCP_PATH: () => "/internal/api/legalentity/v1/ccp",
    GET_FCM_PATH: () => "/internal/api/legalentity/v1/fcm",
    GET_MARGIN_FUNDS: () => "/internal/api/legalentity/v1/funds",
});
